import { makeAutoObservable, runInAction } from 'mobx'
import { history } from '../history'
import agent from '../api/agent'
import { User, UserFormValues } from '../models/user'
import { store } from './store'

export default class UserStore {
  user: User | null = null

  constructor () {
    makeAutoObservable(this)
  }

  get isLoggedIn () {
    return !!this.user
  }

  /** Dependable flag for admin-only UI and behavior. Use in components to show/hide admin actions. */
  get isAdmin () {
    return this.user?.isAdmin === true
  }

  /** True when the current user is a moderator (can access moderation dashboard). */
  get isModerator () {
    return this.user?.isModerator === true
  }

  login = async (creds: UserFormValues) => {
    try {
      const user = await agent.Account.login(creds)
      store.commonStore.setToken(user.token)
      runInAction(() => (this.user = user))
      store.notificationStore.startPolling()
      history.push('/blog')
      store.modalStore.closeModal()
    } catch (error) {
      throw error
    }
  }

  logout = () => {
    store.notificationStore.stopPolling()
    store.commonStore.setToken(null)
    window.localStorage.removeItem('jwt')
    this.user = null
    history.push('/')
  }

  getUser = async () => {
    try {
      const user = await agent.Account.current()
      runInAction(() => (this.user = user))
      store.notificationStore.startPolling()
    } catch (error: any) {
      if (error?.response?.status === 401) {
        runInAction(() => {
          this.user = null
          store.commonStore.setToken(null)
        })
      }
      console.log(error)
    }
  }

  register = async (creds: UserFormValues) => {
    try {
      const user = await agent.Account.register(creds)
      store.commonStore.setToken(user.token)
      runInAction(() => (this.user = user))
      store.notificationStore.startPolling()
      history.push('/blog')
      store.modalStore.closeModal()
    } catch (error) {
      throw error
    }
  }

  setImage = (image: string) => {
    if (this.user) this.user.image = image
  }

  setDisplayName = (displayName: string) => {
    if (this.user) this.user.displayName = displayName
  }
}
